function About() {
  return (
    <div className="About">
      <p>I work on software.</p>
    </div>
  );
}

export default About;
